import { api } from './client.ts';
import type { AppSettings, UpdateSettingsDto, BzWorkflow } from '@rpgspeak/shared';

export const settingsApi = {
  get: () => api.get<AppSettings>('/settings'),
  update: (data: UpdateSettingsDto) => api.patch<AppSettings>('/settings', data),
  reset: () => api.post<AppSettings>('/settings/reset', {}),
  getDefault: <K extends keyof AppSettings>(key: K) =>
    api.get<{ key: K; value: AppSettings[K] }>(`/settings/defaults/${key}`),
  bzComfyWorkflows: () => api.get<BzWorkflow[]>('/settings/bzcomfy-workflows'),
  comfyUiWorkflows: () => api.get<BzWorkflow[]>('/settings/comfyui-workflows'),
  bzComfyLoras: () => api.get<string[]>('/settings/bzcomfy-loras'),
  comfyUiResolutionOptions: () =>
    api.get<{ megapixels: string[]; aspectRatios: string[] }>('/settings/comfyui-resolution-options'),
  bzComfyResolutionOptions: () =>
    api.get<{ megapixels: string[]; aspectRatios: string[] }>('/settings/bzcomfy-resolution-options'),
};
